import { ParaglidingIcon } from './ParaglidingIcon';

/**
 * author: Google
 * id 24CD918E-9458-4D8D-A00C-746F8AB5D17E
 * name paragliding
 * version: 6.1.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/paragliding.svg
 * tags
 * - Sport 
 */
export const ParasailIcon = ParaglidingIcon;
export default ParasailIcon